// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import getOnlineCourseDataActions from './getOnlineCourseDataActions';
import getOnlineCourseContentsDataActions from './getOnlineCourseContentsDataActions';
import createOnlineCourseNoteActions from './createOnlineCourseNoteActions';
import updateOnlineCourseNoteActions from './updateOnlineCourseNoteActions';
import deleteOnlineCourseNoteActions from './deleteOnlineCourseNoteActions';
import updateOnlineCourseProgressActions from './updateOnlineCourseProgressActions';
import getOnlineCourseNotesDataActions from './getOnlineCourseNotesDataActions';
import sendVisitedOnlineCourseActions from './sendVisitedOnlineCourseActions';

export default {
  getOnlineCourseDataActions,
  getOnlineCourseContentsDataActions,
  getOnlineCourseNotesDataActions,
  createOnlineCourseNoteActions,
  updateOnlineCourseNoteActions,
  deleteOnlineCourseNoteActions,
  updateOnlineCourseProgressActions,
  sendVisitedOnlineCourseActions
}
